export { default } from './TeacherEdit';

